import * as React from 'react';
import { Location, matchRoutes } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Menu from '@mui/material/Menu';

import { DropdownMenuItem } from '../../../utils/menus';
import { MenuDropdownItem } from './MenuDropdownItem';

interface MenuDropdownProps {
  dropdown: DropdownMenuItem;
  location: Location;
}

export const MenuDropdown: React.FC<MenuDropdownProps> = ({ dropdown, location }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [isLinkActive, setIsLinkActive] = React.useState(false);
  const open = Boolean(anchorEl);

  const handleClick: React.MouseEventHandler<HTMLDivElement> = (event) => {
    setAnchorEl(event.currentTarget);
    setIsLinkActive(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setIsLinkActive(false);
  };

  React.useEffect(() => {
    const pages = dropdown.children.map((item) => item.page);
    const isPathActive = !!matchRoutes(pages, location);
    setIsLinkActive(isPathActive);
  }, [location, dropdown.children]);

  return (
    <div>
      <div
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <div
          className={`flex space-x-1 items-end py-1 px-4 rounded-md text-blue-300 font-semibold cursor-pointer ${
            isLinkActive ? 'text-white ' : 'text-blue-400'
          } hover:bg-darkblue-900`}
        >
          <h4>{dropdown.title}</h4>
          <KeyboardArrowDownIcon style={{ fontSize: '20px' }} />
        </div>
      </div>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        style={{
          zIndex: '1500',
        }}
      >
        <ul className="flex flex-col items-start max-w-[380px]">
          {dropdown.children.map((item) => (
            <MenuDropdownItem item={item} onClose={handleClose} key={item.page.path} />
          ))}
        </ul>
      </Menu>
    </div>
  );
};
MenuDropdown.displayName = 'DesktopNav.MenuDropdown';
